export const API_BASE_URL = process.env.REACT_APP_API || 'http://localhost:3001/api/v1';

export const API_ENDPOINTS = {
  // Authentication endpoints
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
  VERIFY_RESET_TOKEN: 'verify-reset-token',
  RESET_PASSWORD: 'reset-password',
  VERIFY_EMAIL: 'confirm-account',
  VERIFY_CONFIRM_TOKEN: 'verify-confirm-token',
  RESEND_VERIFICATION: 'resend-verification',
  
  // User endpoints
  LOGOUT: 'users/logout',
  USER_LOGIN_TIME: 'user/login-time',
  FETCH_USER: 'normal-user/account-information',
  UPDATE_USER: 'normal-user',
  UPDATE_NORMAL_USER: 'normal-user', // Alias for backward compatibility
  DELETE_USER: 'normal-user',
  UPDATE_PROFILE_IMAGE: 'users/profile/picture',
  UPDATE_PROFILE_BANNER: 'users/profile/banner',
  USER_INCOMING_CALL_NOTIFY: 'users/incoming-call/notify',
  USER_MESSAGE_NOTIFY: 'users/message/notify',
  CHECK_USERNAME: 'users/check-username',
  REGISTER: 'register',
  SUBSCRIBER_REGISTER: 'register/normal-user',
  FEATURED_PROFILE: 'user/featuredProfile',
  FEATURED_PROFILE_GUEST: 'user/featuredProfile/guest',
  RECOMMENDED_PROFILE: 'user/recommendedProfile',
  TRENDING_PROFILE: 'user/trending',
  TRENDING_PROFILE_GUEST: 'user/trending/guest',
  
  // Creator endpoints
  CREATOR: 'content-creator',
  CREATOR_REGISTER: 'register/creator',
  CREATOR_SUBSCRIPTION: 'content-creator/subscription-data',
  CREATOR_CONTENT: 'content-creator/content',
  CREATOR_CONTENT_THUMBNAIL: 'content-creator/content/createThumbnail',
  CREATOR_CONTENT_COUNTS: 'content-creators/content/count',
  CREATOR_TOTAL_TIP: 'content-creators/totalTip',
  MESSAGE_TIPS_EARNINGS: 'content-creators/message-tips-earnings',
  
  // File upload endpoints
  GET_PRESIGNED_URL: 'upload/getPresignedUrl',
  GET_PRESIGNED_URL_WITHOUT_AUTH: 'uploadWithOutToken/getPresignedUrl',
  GET_SIGNED_URLS: 'upload/getSignedUrl',
  GET_MULTIPART_PRESIGNED_URLS: 'upload/getPresignedUrlMultipart',
  COMPLETE_MULTIPART_UPLOAD: 'upload/completeMultipart',
  
  // Help/Support endpoints
  CONTACT_FORM: 'contacts',
  REPORT_CONTENT_CREATOR: 'reports/content-creators',
  
  // Category endpoints
  ALL_CATEGORIES_WITH_SUB: 'user/allCategoryWithSub',
  ALL_CATEGORIES: 'user/allCategory',
  CATEGORIES_WITH_COUNT: 'user/categories/count',
  CATEGORY_CREATORS_LIST: 'contentCreator/catogories/list',
  
  // Content Creator endpoints
  CONTENT_CREATOR: 'content-creator',
  CONTENT_CREATOR_GUEST: 'contentCreator/guest',
  CONTENT_CREATORS: 'content-creators',
  CONTENT_CREATOR_LIST: 'contentCreator/list',
  
  // Notification endpoints
  NOTIFICATION_COUNT: 'notifications/count',

  // FCM token endpoint
  UPDATE_FCM_TOKEN: 'users/fcm-token',

  // Promotion endpoints
  GET_PROMOTION: 'promotion',
  CREATE_PROMOTION: 'promotion',
  CANCEL_PROMOTION: 'promotion',
  
  // Follow endpoints
  FOLLOW_PPV_CREATOR: 'follow/ppv-creator',
  FOLLOWERS_LIST: 'contentCreator',
  
  // Subscription endpoints
  BUNDLES: 'bundles',
  SUBSCRIPTION_COUNTS: 'normal-user/subscriptions/count',
  SUBSCRIPTIONS: 'normal-user/subscriptions',
  
  // Transaction endpoints
  TRANSACTIONS: 'users/transactions',
  BALANCE_SUMMARY: 'content-creators/balance-summary',
  TODAY_EARNINGS_SUMMARY: 'content-creators/today-earnings-summary',
  DAILY_EARNINGS: 'content-creators/daily-earnings',
  MONTHLY_EARNINGS: 'content-creators/monthly-earnings',
  TOTAL_EARNINGS_BREAKDOWN: 'content-creators/total-earnings-breakdown',
  TOTAL_EARNINGS_YEARLY: 'content-creators/total-earnings-yearly',
  EARNING_EXPORT_PDF: 'content-creators/earningExportPdf',
  REQUEST_PAYOUT: 'content-creators/cashout/v1',
  REQUEST_PAYOUT_STATUS: 'masspay/requestpayoutstatus',
  TRY_AGAIN_PAYOUT: 'content-creators/cashout-tryagain',
  AFFILIATE_INFORMATION: 'users/affiliate/information',
  MASSPAY_LOOKUP_USER: 'masspay/lookupUser',
  MASSPAY_LIST_SERVICES: 'masspay/listServices',
  MASSPAY_ATTRIBUTES: 'masspay/attributes',
  MASSPAY_SET_ATTRIBUTES: 'masspay/setattributes',
  MASSPAY_PAYMENT_METHOD: 'masspay/paymentMethod',
  MASSPAY_TRANSACTION_HISTORY: 'masspay/transactionHistory',
  W9_CREATE_FORM: 'users/createW9Form',
  W9_GET_FORM: 'users/getW9Form',
  W8_CREATE_FORM: 'users/createW8Form',
  W8_GET_FORM: 'users/getW8Form',
  // CCBill payment endpoints
  CCBILL_CHARGE: 'ccbill/charge',
  CCBILL_TOKEN: 'ccbill/token',
  CCBILL_WEBHOOK: 'ccbill/webhook',
  
  // Card endpoints
  CARD: 'card',
  
  // Tip endpoints
  CONTENT_TIPS: 'contents', // Base path for content tips: /contents/{id}/tips
  MESSAGE_TIPS: 'messages', // Base path for message tips: /messages/{id}/tips
  MESSAGE_TIPS_REPLY: 'messages/tips/reply',
  MESSAGE_TIPS_ADD_MATRIX_ID: 'messages/tips/add-matrixid',
  MESSAGE_TIPS_PENDING_COLLECT: 'messages/tips/pending-collect',
  AUDIENCE_THRESHOLD: 'content-creators/audience-threshold',

  // Feed endpoints
  FEED: 'feed',
  
  // Referral endpoints
  REFERRAL_RULES: 'content-creators/referrals/rules',
  REFERRAL_BONUSES: 'content-creators/referrals/current',
  REFERRAL_BONUS_HISTORY: 'content-creators/referrals/history',
  REFERRAL_AMOUNT: 'content-creators/referrals/amount',
  
  // Matrix endpoints
  MATRIX_REGISTER: 'matrix/register',
  MATRIX_SHORT_LIVED_TOKEN: 'matrix/short-lived-token',
  MATRIX_ROOMS: 'matrix/rooms',
  MATRIX_ROOMS_UPDATE_HASMESSAGE: 'matrix/rooms-update-hasmessage',
  MATRIX_ALL_ROOMS: 'matrix/all-rooms',
  MATRIX_CREATE_OR_GET_ROOM: 'matrix/room',
  MATRIX_ROOM_INFO: 'matrix/room/info',
  MATRIX_DELETE_ROOM: 'matrix/room/delete',
  MATRIX_LEAVE_ROOM: 'matrix/room/leave',

  MESSAGES_RESTRICTED_WORD: 'messages/restricted-word',

  // Payment method endpoints
  PAYMENT_METHOD_SEND_CHANGE_LINK: 'payment-method/send-change-link',
  PAYMENT_METHOD_VALIDATE_CHANGE_CODE: 'payment-method/validate-change-code',

  // Credit endpoints
  PURCHASE_CREDITS: 'purchase-credits',
  PURCHASE_CREDITS_BUY: 'purchase-credits',
  CANCEL_CREDITS_PURCHASE: 'wallet/purchase',
  WALLET_BALANCE: 'wallet/balance',
  DEDUCT_CALL_CREDIT: 'wallet/deduct-call-credit',
};